import { Logo } from '../assets/Logo';
import { scrollToLandingSection } from '../utils/landingScroll';
import { AppStoreButton } from './AppStoreButton';
import { BrandWordmark } from './BrandWordmark';
import { PlayStoreButton } from './PlayStoreButton';

export const Hero = () => {
  return (
    <section
      className="landing-snap-panel relative flex items-center justify-center px-4 sm:px-6 md:pt-20 md:pb-20 text-center md:min-h-landing-panel"
      aria-labelledby="hero-heading"
      aria-describedby="hero-description"
    >
      <div className="w-full max-w-5xl">
        <div className="flex flex-col items-center gap-6 md:gap-8 px-4">
          <Logo className="size-20 sm:size-24 md:size-28" decorative />

          <div className="space-y-3 md:space-y-4 max-w-2xl">
            <p className="font-display text-lg sm:text-xl text-[#638888] italic font-normal">
              Welcome to
            </p>
            <BrandWordmark
              as="h1"
              id="hero-heading"
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1.05]"
            />
            <p
              id="hero-description"
              className="text-base sm:text-lg md:text-xl text-[#638888] max-w-xl mx-auto leading-relaxed"
            >
              Pin memories to real places. Explore spots, save your go-back list, and follow friends.
              Free on iPhone and Android.
            </p>
          </div>

          <div className="flex w-full max-w-xs sm:max-w-md flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
            <AppStoreButton className="w-full sm:flex-1" />
            <PlayStoreButton className="w-full sm:flex-1" />
          </div>

          <a
            href="#feed"
            onClick={(event) => {
              event.preventDefault();
              scrollToLandingSection('feed');
            }}
            className="mt-4 inline-flex flex-col items-center gap-2 text-sm font-medium text-[#638888] hover:text-[#111818] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded-lg px-2 py-1"
          >
            <span>Learn more</span>
            <svg
              className="size-5 motion-safe:animate-bounce motion-reduce:animate-none"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};
